import Head from "next/head";
import { ISEOProps } from "./types";
import { Fragment } from "react";

const SEO: React.FC<ISEOProps> = ({
  title = "Quira",
  description = "Build developer ecosystems with quests on GitHub.",
  ogImage = `${process.env.NEXT_PUBLIC_SITE_ORIGIN}/images/og/og.png`,
}) => {
  const _renderPreconnectDnsPrefetchLinks = () => {
    return [process.env.NEXT_PUBLIC_BACKEND_DOMAIN].map((domain) => (
      <Fragment key={domain}>
        <link rel="dns-prefetch" href={domain} />
        <link rel="preconnect" href={domain} />
      </Fragment>
    ));
  };

  return (
    <Head>
      <title>{title}</title>
      {_renderPreconnectDnsPrefetchLinks()}
      <meta name="description" content={description} key="description" />
      <meta property="og:title" content={title} key="og:title" />
      <meta
        property="og:description"
        content={description}
        key="og:description"
      />
      <meta property="og:image" content={ogImage} key="og:image" />
      <meta name="twitter:title" content={title} key="twitter:title" />
      <meta
        name="twitter:description"
        content={description}
        key="twitter:description"
      />
      <meta name="twitter:image" content={ogImage} key="twitter:image" />
    </Head>
  );
};

export default SEO;
